import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';

import ContactInfo from './ContactInfo'

class Contact extends Component {
  render() {
    return (
      <Grid container spacing={24} align='center' justify='center' className='contact'>
        <Grid item xs={12}>
            <Typography variant="display2" gutterBottom className="contactHeading">
              Kontakt
            </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper style={{padding: '2rem'}}>
            <ContactInfo itemAlign='center'/>
            <a href='https://www.facebook.com/PoliklinikaSente/' target='_blank' rel="noopener noreferrer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><title>Posetite nas na Facebook-u</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className='facebookLogo' d="M25.76,46.32h6.74V30H37l.6-5.62h-5.1V21.56c0-1.47.14-2.25,2.24-2.25h2.81V13.68h-4.5c-5.41,0-7.31,2.73-7.31,7.32v3.38H22.4V30h3.37ZM30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60Z" fill="#757575"/></g></g></svg>
            </a>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <iframe title='Mapa do poliklinike Sente' src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d5533.61383341125!2d19.666085000000002!3d46.094826!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d46.094826!2d19.6660851!5e0!3m2!1sen!2srs!4v1521054557229" width="100%" height="450" frameBorder="0" style={{border:0}} allowFullScreen></iframe>
        </Grid>
      </Grid>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js